/**
 * Nom de fichier standard pour tout document téléchargé (contrat, devis, facture...) :
 * NOMETABLISSEMENT-TYPEDOCUMENT-IDENTIFIANT.pdf, ex. IAMANI-CONTRAT-PREMIUM,
 * IAMANI-DEVIS-D2026-042 — demande d'Emeni (2026-09-05).
 */
const sanitizeSegment = (value: string) =>
    (value || '')
        .normalize('NFD').replace(/\p{Diacritic}/gu, '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

export function buildDocumentFilename(companyName: string, docType: string, identifier?: string): string {
    const parts = [sanitizeSegment(companyName) || 'DOCUMENT', sanitizeSegment(docType)];
    if (identifier) parts.push(sanitizeSegment(identifier));
    return `${parts.filter(Boolean).join('-')}.pdf`;
}
